import { createContext, useState, useEffect } from "react";
import { AuthAPI, UserAPI, WalletAPI } from "../services/api";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [profile, setProfile] = useState(null);
  const [balance, setBalance] = useState(0);

  // ✅ Balance fetch fonksiyonu
  const fetchBalance = async () => {
    try {
      const res = await WalletAPI.balance();
      setBalance(res.data.balance);
    } catch (err) {
      setBalance(null);
    }
  };

  // login fonksiyonu
  const login = async (data, method) => {
    try {
      if (method === "password") {
        const res = await AuthAPI.loginPassword(data);
        localStorage.setItem("access_token", res.data.access);
      } else if (method === "otp-send") {
        await AuthAPI.loginOTP({ phone_number: data.phone_number });
        return; // OTP gönderildi
      } else if (method === "otp-verify") {
        const res = await AuthAPI.verifyLoginOTP(data);
        localStorage.setItem("access_token", res.data.access);
      }

      // login başarılı → profil getir
      const profileRes = await UserAPI.getProfile();
      setProfile(profileRes.data);

      // ✅ balance güncelle
      await fetchBalance();
    } catch (err) {
      throw err; // interceptor toast gösteriyor
    }
  };

  // logout fonksiyonu
  const logout = () => {
    localStorage.removeItem("access_token");
    setProfile(null);
    setBalance(0); // ✅ logout sonrası sıfırla
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    if (token) {
      UserAPI.getProfile()
        .then((res) => {
          setProfile(res.data);
          fetchBalance(); // ✅ profil yüklendiğinde balance da çek
        })
        .catch(() => setProfile(null));
    }

    // ✅ force-logout event listener
    const handleForceLogout = () => {
      logout();
      window.location.href = "/login";
    };

    window.addEventListener("force-logout", handleForceLogout);
    return () => {
      window.removeEventListener("force-logout", handleForceLogout);
    };
  }, []);

  return (
    <AuthContext.Provider
      value={{ profile, setProfile, balance, setBalance, login, logout, fetchBalance }}
    >
      {children}
    </AuthContext.Provider>
  );
};
